import React from 'react';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import useStyles from './style';
const CardLoader = ({ pageSize = 5 }) => {
  const classes = useStyles();
  if (pageSize === -1) {
    pageSize = 10;
  }

  return (
    <div className={clsx('p-3', classes.wrapper)}>
      <div className={clsx('d-flex f-wrap')}>
        {new Array(pageSize).fill('Loading').map((element, elementIndex) => (
          <Paper
            key={`grid-card-loader-element-${elementIndex}`}
            className={clsx('m-3', classes.paper)}
            elevation={4}
          >
            <div
              className={clsx(
                'd-flex flex-column f-align-center pt-8',
                classes.content
              )}
            >
              <div className={clsx('loading', classes.icon)}></div>
              <div
                className='mt-3 loading'
                style={{
                  width: 200,
                  height: 40,
                }}
              >
                <span className='v-hidden'>{element}</span>
              </div>
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );
};

export default CardLoader;
